import { canUseOrderManagement } from 'shared/lib/roles';

/** Packing List는 해상 수입(0)·항공 수입(2)에만 올린다(D6). 다른 유형에는 House에 붙일 PL이 없다. */
export const ORDER_MANAGEMENT_TABS = [0, 2];

/** 공개 전 화면에 들어가는 주소 표식. 메뉴에는 없고 /shipments?ordermanagement=1처럼 직접 붙여야 한다. */
export const ORDER_MANAGEMENT_QUERY_KEY = 'ordermanagement';

/** 이 페이지 주소에 Order Management 표식이 붙어 있는지. */
export const hasOrderManagementQuery = (search = typeof window !== 'undefined' ? window.location.search : '') =>
    new URLSearchParams(search).has(ORDER_MANAGEMENT_QUERY_KEY);

/**
 * 상세 패널에 Operation / Order Management 전환을 띄울지. 공개 전이라 두 겹으로 막는다:
 * 주소에 표식(?ordermanagement=1)을 붙였고 Administrator여야 하며, PL을 받는 운송 유형이어야 한다.
 * 하나라도 빠지면 Operation 패널만 그려진다. 공개할 때 표식·역할 조건을 함께 걷어낸다.
 */
export const isOrderManagementAvailable = (userRole, tabValue, hasQuery = hasOrderManagementQuery()) =>
    hasQuery && canUseOrderManagement(userRole) && ORDER_MANAGEMENT_TABS.includes(tabValue);
